import { Side, Position } from "@/types";

export const pointerWidth = 25;
export const pointerHeight = 25;
export const pointerHypot = Math.floor(Math.sqrt(Math.pow(pointerWidth, 2) + Math.pow(pointerHeight, 2)) * 100) / 100;

export class Pointer {
  side: Side;
  centered: boolean;
  pointerElem: HTMLDivElement;

  constructor(side: Side, centered: boolean, pointerElem: HTMLDivElement) {
    this.side = side;
    this.centered = centered;
    this.pointerElem = pointerElem;
  }

  // prettier-ignore
  getPointerPositionLeft(componenetRef: HTMLDivElement, modalBody: HTMLDivElement): Position {
    const refBoundingRect = componenetRef.getBoundingClientRect();
    const modalBodyBoundingRect = modalBody.getBoundingClientRect();

    const left = -pointerWidth * .25;
    const top = refBoundingRect.top - modalBodyBoundingRect.top + refBoundingRect.height / 2 - pointerHeight / 2;

    return { left, top };
  }

  // prettier-ignore
  getPointerPositionTop(componenetRef: HTMLDivElement, modalBody: HTMLDivElement): Position {
    const refBoundingRect = componenetRef.getBoundingClientRect();
    const modalBodyBoundingRect = modalBody.getBoundingClientRect();

    const left = refBoundingRect.left - modalBodyBoundingRect.left + refBoundingRect.width / 2 - pointerWidth / 2;
    const top = -pointerHeight * .25;
    
    return { left, top };
  }

  // prettier-ignore
  getPointerPositionBottom(componenetRef: HTMLDivElement, modalBody: HTMLDivElement): Position {
    const refBoundingRect = componenetRef.getBoundingClientRect();
    const modalBodyBoundingRect = modalBody.getBoundingClientRect();

    const left = refBoundingRect.left - modalBodyBoundingRect.left + refBoundingRect.width / 2 - pointerWidth / 2;
    const top = modalBodyBoundingRect.height - pointerHeight * .75;

    return { left, top };
  }

  getPointerCenetered(modalBody: HTMLDivElement): Position {
    switch (this.side) {
      case "left": {
        const modalBodyBoundingRect = modalBody.getBoundingClientRect();

        const left = -pointerWidth * 0.25;
        const top = modalBodyBoundingRect.height / 2 - pointerHypot / 2;

        return { left, top };
      }
      case "top": {
        const modalBodyBoundingRect = modalBody.getBoundingClientRect();

        const left = modalBodyBoundingRect.width / 2 - pointerWidth / 2;
        const top = -pointerHeight * 0.25;

        return { left, top };
      }
      case "right": {
        const modalBodyBoundingRect = modalBody.getBoundingClientRect();

        const left = modalBodyBoundingRect.width - pointerWidth * 0.75;
        const top = modalBodyBoundingRect.height / 2 - pointerHeight / 2;

        return { left, top };
      }
      case "bottom": {
        const modalBodyBoundingRect = modalBody.getBoundingClientRect();

        const left = modalBodyBoundingRect.width / 2 - pointerWidth / 2;
        const top = modalBodyBoundingRect.height - pointerHeight * 0.75;

        return { left, top };
      }
      case "none": {
        return { left: pointerWidth / 2, top: pointerHeight / 2 };
      }
    }
  }
}
